import '../LoginStyle.css';
import { useNavigate } from 'react-router-dom';
import cancel_button from '../../resources/cancel_button.png';

function Popup(props) {
  let navigate = useNavigate();

  return (
    <div className="popup-box">
      <div className="popup-body">
      <button className="cancel-btn" onClick={props.handleClose}>
        <img src={cancel_button}  alt = "" width={"30px"} height={"30px"}/>
      </button>
      <p className="text">Email</p>
      <p className="text">Confirming to recover password ...</p>
        <button className="btn" onClick={()=> navigate('/login/reset-password')}>
          Enter
        </button>
      </div>
    </div>
  );
}

export default Popup;